import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'om-visit-follow-up-order-completion',
  templateUrl: './visit-follow-up-order-completion.component.html',
  styleUrls: ['./visit-follow-up-order-completion.component.scss'],
})
export class VisitFollowUpOrderCompletionComponent implements OnInit {
  @Output() completed = new EventEmitter();

  modalRef: NgbModalRef;
  @ViewChild('modal', { static: true }) modal;

  constructor(private modalService: NgbModal) {}

  ngOnInit() {}

  open() {
    this.modalRef = this.modalService.open(this.modal);
  }

  close() {
    this.modalRef.close();
  }

  complete() {
    this.completed.emit({});
  }
}
